import { useEffect, useState } from "react";
import { rpcCall } from "../ws/client";

/**
 * Hook to get current TON network from backend
 * Returns "mainnet" or "testnet"
 */
export function useNetwork() {
    const [network, setNetwork] = useState<"mainnet" | "testnet">("testnet");
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadNetwork();
    }, []);

    const loadNetwork = async () => {
        try {
            const response = await rpcCall<{}, { network: string }>("network.get", {});
            if (response.result?.network) {
                const detectedNetwork = response.result.network as "mainnet" | "testnet";
                setNetwork(detectedNetwork);
            }
        } catch (err) {
            console.error("Failed to get network:", err);
            // Default to testnet on error
            setNetwork("testnet");
        } finally {
            setLoading(false);
        }
    };

    return { network, loading, refresh: loadNetwork };
}
